import { Device, User } from '.';
import { FolderConf } from './syncthing/folder-conf.model';

export class ContentTag {
  public _id: string;
  public type: string;
  public data: {
    name: string,
  };
}
export class Content {
  public _id?: string;
  public devicesSubscribed?: number;
  public devices?: any;
  public createdAt?: number;
  public updatedAt?: number;
  public type?: string;
  public description?: string;
  // public tags?: string[];
  public password?: string;
  public name?: string;
  public sortPriority?: number;
  public owner?: User;
  public collaborators?: User[];
  public thumbnailPath?: string;
  public subscribedDevices?: Device[];
  public conf?: any;
  public visibility?: boolean;
  public featured?: boolean;
  public paused?: boolean;
  public folderId?: string;
  public completion?: {
    completion?: number; // percentage
    doneBytes?: number;
    doneItems?: number;
    doneFiles?: number;
    needBytes?: number;
    needFiles?: number;
    globalBytes?: number;
    isImported?: boolean;
  };
  public restrictKiwix?: boolean;
  public language?: string;
  public summary?: {};
  public size?: number;
  public files?: number;
  public directories?: number;
  public responses?: any[];
  public structuredId?: string;
  public subject?: ContentTag;
  public grade?: ContentTag;
  public topics?: ContentTag[];
}
